@app.directive 'bannerJoule1', (AnalyticsService) ->
  restrict: 'E'
  scope: {}
  controllerAs: 'bannerJoule1'
  controller: ->

    @track = ->
      AnalyticsService.track 'Banner Clicked', {name: 'bannerJoule1'}

    this

  link: (scope, element, attrs) ->

  bindToController: {
    theme: '='
    content: '='
  }
  templateUrl: "/assets/templates/components/banner/bannerJoule1/bannerJoule1.html"
